import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { NgChartsModule } from 'ng2-charts';
import { GlobalModule } from '../global/global.module';

import { MeterDashboardComponent } from './components/meter-dashboard/meter-dashboard.component';
import { MeterListComponent } from './components/meter-list/meter-list.component';
import { MeterAnalyticsComponent } from './components/meter-analytics/meter-analytics.component';
import { MeterConfigComponent } from './components/meter-config/meter-config.component';
import { MeterUserDetailDialogComponent } from './components/meter-user-detail-dialog/meter-user-detail-dialog.component';
import { MeterKpiCardsComponent } from './components/meter-analytics/meter-kpi-cards/meter-kpi-cards.component';
import { MeterStatusChartComponent } from './components/meter-analytics/meter-status-chart/meter-status-chart.component';
import { MeterAlertTypeChartComponent } from './components/meter-analytics/meter-alert-type-chart/meter-alert-type-chart.component';
import { MeterConsumptionTrendComponent } from './components/meter-analytics/meter-consumption-trend/meter-consumption-trend.component';
import { MeterAlertTrendComponent } from './components/meter-analytics/meter-alert-trend/meter-alert-trend.component';
import { MeterTopConsumersComponent } from './components/meter-analytics/meter-top-consumers/meter-top-consumers.component';
import { MeterHeatmapComponent } from './components/meter-analytics/meter-heatmap/meter-heatmap.component';
import { MeterInventoryComponent } from './components/meter-list/meter-inventory/meter-inventory.component';
import { MeterAlertsComponent } from './components/meter-list/meter-alerts/meter-alerts.component';
import { MeterUnassignedComponent } from './components/meter-list/meter-unassigned/meter-unassigned.component';
import { MeterHealthComponent } from './components/meter-list/meter-health/meter-health.component';
import { LinkMeterDialogComponent } from './components/meter-list/link-meter-dialog/link-meter-dialog.component';
import { MeterAnalyticsService } from './services/meter-analytics.service';
import { MeterSettingsService } from './services/meter-settings.service';
import { METER_SERVICE_PROVIDER } from './services/meter.service';

@NgModule({
    declarations: [
        MeterDashboardComponent,
        MeterListComponent,
        MeterAnalyticsComponent,
        MeterConfigComponent,
        MeterUserDetailDialogComponent,
        MeterKpiCardsComponent,
        MeterStatusChartComponent,
        MeterAlertTypeChartComponent,
        MeterConsumptionTrendComponent,
        MeterAlertTrendComponent,
        MeterTopConsumersComponent,
        MeterHeatmapComponent,
        MeterInventoryComponent,
        MeterAlertsComponent,
        MeterUnassignedComponent,
        MeterHealthComponent,
        LinkMeterDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        TranslateModule,
        MatTabsModule,
        MatTableModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatChipsModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        NgChartsModule,
        GlobalModule,
    ],
    providers: [METER_SERVICE_PROVIDER, MeterAnalyticsService, MeterSettingsService],
    exports: [MeterDashboardComponent],
})
export class MeterModule {}
